module.exports = __webpack_public_path__ + "static/media/nrpu.2ee41a06.png";